'use client'

import { ExternalLinkIcon, InstagramLogoIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router';
import '../App.css';
import CM_Logo from '../CM_Digital_Logo.webp';
import logo from '../icon.png';
import { Separator } from './ui/separator';

function Footer() {
    return (
        <div >
            <Separator className='mt-6' />
            <div className='w-full flex justify-center'>
                <div className='w-3/4 flex flex-col py-6 gap-8'>
                    <div className='w-full h-fit grid grid-cols-1 lg:grid-cols-6 gap-6 lg:gap-3'>
                        <div className='flex flex-col gap-3 lg:col-span-3'>
                            <Link to='/' className='flex items-center gap-3 hover:underline font-semibold'>
                                <img src={logo} className='AppLogo' alt='STAMP logo'></img>SKHRFS Tävling Anmälans och Medlems Portal
                            </Link>
                            <p className='text-sm'>
                                SKHRFS Tävling Anmälans och Medlems Portal, STAMP, är Sveriges Kaninhoppares Riksförbunds, SKHRF, system för att anmäla sig till tävlingar och se resultat.
                            </p>
                            <p className='text-sm'>
                                Sveriges Kaninhoppares Riksförbund, SKHRF, är en rikstäckande ideell organisation med huvudfokus på kaninhoppning.
                            </p>
                            <div className='flex gap-6'>
                                <a href='https://www.instagram.com/skhrf/' rel='noopener noreferrer' target='_blank'>
                                    <InstagramLogoIcon className='size-6 hover:text-skhrf-blue' />
                                </a>
                                <a href='https://www.tiktok.com/@skhrf_' rel='noopener noreferrer' target='_blank' className='hover:fill-skhrf-blue'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className='size-6'><path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" /></svg>
                                </a>
                                <a href='https://www.facebook.com/skhrf/' rel='noopener noreferrer' target='_blank' className='hover:fill-skhrf-blue'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className='size-6'><path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z" /></svg>
                                </a>
                            </div>
                        </div>
                        <div className='flex flex-col lg:col-start-5 gap-3 items-start'>
                            <a href='mailto:styrelsen@skhrf.se' className='hover:underline flex gap-1 items-center text-sm'>
                                Styrelsen@skhrf.se <ExternalLinkIcon />
                            </a>
                            <div>
                                <p className='text-sm'>
                                    Gårdsvägen 49
                                </p>
                                <p className='text-sm'>
                                    17550 Järfälla
                                </p>
                            </div>
                        </div>
                        <div className='flex flex-col gap-3 items-start'>
                            <a href='https://skhrf.se/' rel='noopener noreferrer' target='_blank' className='hover:underline flex gap-1 items-center text-sm'>
                                SKHRFs hemsida <ExternalLinkIcon />
                            </a>
                            <a href='https://skhrf.se/integritetspolicy/' rel='noopener noreferrer' target='_blank' className='hover:underline flex gap-1 items-center text-sm'>
                                Integritetspolicy <ExternalLinkIcon />
                            </a>
                            <a href='https://skhrf.se/om-skhrf/foreningar/' rel='noopener noreferrer' target='_blank' className='hover:underline flex gap-1 items-center text-sm'>
                                Hitta förening <ExternalLinkIcon />
                            </a>
                            <a href='https://skhrf.se/om-skhrf/dokument/' rel='noopener noreferrer' target='_blank' className='hover:underline flex gap-1 items-center text-sm'>
                                Dokument <ExternalLinkIcon />
                            </a>
                        </div>
                    </div>
                    <div className='flex flex-col items-center text-sm'>
                        <a href='https://www.cmdigital.se/' target='_blank' rel="noreferrer">
                            <img src={CM_Logo} className='h-8' alt='CM Digital AB logo'></img>
                        </a>
                        <p className='text-sm text-muted-foreground text-center'>
                            © 2025 Sveriges Kaninhoppares Riksförbund, SKHRF
                        </p>
                        <p className='text-sm text-muted-foreground text-center'>Version {process.env.REACT_APP_VERSION}</p>
                    </div>
                </div>
            </div >
        </div>
    );
}

export default Footer;